import { useApiData } from '../client';
import type { SelectableBillingCode } from '../../types/media-sim';

/**
 * Practice development and new business codes a user can pick when the client
 * billing code does not exist yet. Client codes are not listed: there is no
 * register of them, so those are typed.
 */
export function useSelectableBillingCodes() {
  return useApiData<SelectableBillingCode[]>('/media-sim/billing-codes/');
}
